import apiClient from "../../helpers/apiClient"
import { createLoadingSelector } from "./Loading"

export const FETCH_EGIFT_PURCHASE_HISTORY = "FETCH_EGIFT_PURCHASE_HISTORY"
export const FETCH_EGIFT_PURCHASE_HISTORY_REQUEST = "FETCH_EGIFT_PURCHASE_HISTORY_REQUEST"
export const FETCH_EGIFT_PURCHASE_HISTORY_SUCCESS = "FETCH_EGIFT_PURCHASE_HISTORY_SUCCESS"
export const FETCH_EGIFT_PURCHASE_HISTORY_FAILURE = "FETCH_EGIFT_PURCHASE_HISTORY_FAILURE"

const initialState = {
	purchaseHistories: {},
	errorMessage: "",
	successMessage: "",
}

export const fetchingEgiftPurchaseHistorySelector = createLoadingSelector([
	FETCH_EGIFT_PURCHASE_HISTORY,
])
export const fetchEgiftPurchaseHistory = (d) => (dispatch, getState) => {
	const isFetching = fetchingEgiftPurchaseHistorySelector(getState())
	if (!d || isFetching) return Promise.resolve()

	return dispatch({
		types: [
			FETCH_EGIFT_PURCHASE_HISTORY_REQUEST,
			FETCH_EGIFT_PURCHASE_HISTORY_SUCCESS,
			FETCH_EGIFT_PURCHASE_HISTORY_FAILURE,
		],
		callAPI: (config) => apiClient.post("api/Egifting/GetHistory", d, config),
		payload: { d },
	})
}

export default function reducer(state = initialState, action) {
	const { payload, errorMessage, successMessage } = action
	switch (action.type) {
		case FETCH_EGIFT_PURCHASE_HISTORY_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case FETCH_EGIFT_PURCHASE_HISTORY_SUCCESS:
			return { ...state, purchaseHistories: payload, successMessage }
		case FETCH_EGIFT_PURCHASE_HISTORY_FAILURE:
			return { ...state, errorMessage }
		default:
			return state
	}
}
